import * as React from "react";
import * as ReactDOM from "react-dom";
import "./Dialog.scss";

interface IDialogProps {
    title: string;
    isOpen: boolean;
    disableClose?: boolean;
    onOpen?: () => void;
    onClose?: () => void;
    width?: number;
    className?: string;
}

interface IDialogState {
    status?: string;
}

export default class Dialog extends React.PureComponent<IDialogProps, IDialogState> {
    constructor(props: IDialogProps) {
        super(props);
        this.state = {};
        this._divRoot = document.createElement("div");
    }

    _divRoot: HTMLDivElement;

    transitionOpen() {
        document.body.appendChild(this._divRoot);
        window.setTimeout(() => this.setState({ status: "open" }, () => window.setTimeout(() => this.props.onOpen?.(), 250)), 50);
    }

    transitionClose() {
        this.setState({ status: "closing" }, () => window.setTimeout(() => 
            this.setState({ status: "" }, () => document.body.removeChild(this._divRoot)), 350));
    }

    componentDidMount() {
        if (this.props.isOpen)
            this.transitionOpen();
    }

    componentDidUpdate(props: IDialogProps) {
        if (props.isOpen && !this.props.isOpen)
            this.transitionClose();
        else if (!props.isOpen && this.props.isOpen)
            this.transitionOpen();
    }

    componentWillUnmount() {
        if (this._divRoot.parentElement)
            document.body.removeChild(this._divRoot)
    }

    render() {
        if (!this.props.isOpen && !this.state.status) return null;

        return ReactDOM.createPortal(<React.Fragment>
            <div className={`dialog-background ${this.state.status ?? ""}`}>
                <div className={`dialog ${this.state.status ?? ""} ${this.props.className ?? ""}`}>
                    <header>
                        <h3>{this.props.title}</h3>
                        {!(this.props.disableClose ?? false) &&
                            <div className="close-button" onClick={this.props.onClose}>
                                <svg viewBox="0 0 14 14">
                                    <path d="M14.5,1.5l-13,13m0-13,13,13" transform="translate(-1 -1)"></path>
                                </svg>
                            </div>}
                    </header>
                    <main>
                        {this.props.children}
                    </main>
                </div>
            </div>
            </React.Fragment>, this._divRoot);
    }
}